import {
  RETURN_APPROVALS_LIST_COUNT_ERROR,
  RETURN_APPROVALS_LIST_ERROR,
  CLEAR_SUBMIT_RETURN_APPROVALS_ACTION_ERROR,
  CLOSE_RETURN_APPROVALS_ACTION_MODAL,
  OPEN_RETURN_APPROVALS_ACTION_MODAL,
  SET_RETURN_APPROVALS_FORM,
  SET_RETURN_APPROVALS_LIST,
  SET_RETURN_APPROVALS_LIST_COUNT,
  SET_RETURN_APPROVALS_PENDING,
  SET_PAGE_SIZE_GLOBAL,
  SUBMIT_RETURN_APPROVALS_ACTION_ERROR,
  SUBMIT_RETURN_APPROVALS_ACTION_PENDING,
  SUBMIT_RETURN_APPROVALS_ACTION_SUCCESS,
  SET_ACTION,
  SET_SELECTED_REQUEST_ID,
} from "./actionTypes";

const initialState = {
  //-------------------------------RETURN-APPROVALS-LIST------------------------------------------
  isGetReturnApprovalsPending: false,
  returnApprovals: [],
  totalRecords: 0,
  returnApprovalListCount: 0,
  returnApprovalListError: null,
  pageSizeGlobal: 0,
  //-------------------------------RETURN-APPROVALS-ACTIONS---------------------------------------
  action: null,
  selectedId: null,
  isReturnApprovalActionModalOpen: false,
  isPending: false,
  errorMessage: null,
  returnApprovalsForm: {},
  isApprovalRejectedSuccess: false,

};

export default (localState = initialState, action) => {
  switch (action.type) {

    case SET_PAGE_SIZE_GLOBAL: {
      const { pageSize } = action.payload;
      return {
        ...localState,
        pageSizeGlobal: pageSize
      };
    }

    //-------------------------------RETURN-APPROVALS-LIST------------------------------------------
    case SET_RETURN_APPROVALS_PENDING: {
      return {
        ...localState,
        isGetReturnApprovalsPending: true,
      };
    }
    case SET_RETURN_APPROVALS_LIST: {
      const { returnApprovalsOdata } = action.payload;
      return {
        ...localState,
        isGetReturnApprovalsPending: false,
        returnApprovalListError: null,
        returnApprovals: returnApprovalsOdata && returnApprovalsOdata.value,
        totalRecords: returnApprovalsOdata && returnApprovalsOdata['@odata.count'],
        isApprovalRejectedSuccess: false,
      };
    }
    case SET_RETURN_APPROVALS_LIST_COUNT: {
      const { returnApprovalsOdata } = action.payload;
      return {
        ...localState,
        returnApprovalListCount: returnApprovalsOdata && returnApprovalsOdata['@odata.count'],
      };
    }
    case RETURN_APPROVALS_LIST_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        returnApprovalListError: errorMessage,
        isGetReturnApprovalsPending: false,
        returnApprovals: [],
        totalRecords: 0
      };
    }
    case RETURN_APPROVALS_LIST_COUNT_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        returnApprovalListCount: 0
      };
    }

    //-------------------------------RETURN-APPROVALS-ACTIONS---------------------------------------
    case SET_ACTION: {
      const { actionType } = action.payload;
      return {
        ...localState,
        action: actionType
      };
    }
    case SET_SELECTED_REQUEST_ID: {
      const { selectedId } = action.payload;
      return {
        ...localState,
        selectedId: selectedId,
      };
    }
    case SUBMIT_RETURN_APPROVALS_ACTION_SUCCESS: {
      return {
        ...localState,
        isPending: false,
        isApprovalRejectedSuccess: true,
      };
    }
    case SET_RETURN_APPROVALS_FORM: {
      const { returnApprovalsForm } = action.payload;
      return {
        ...localState,
        returnApprovalsForm: returnApprovalsForm
      };
    }
    case SUBMIT_RETURN_APPROVALS_ACTION_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        errorMessage,
        isPending: false,
      };
    }
    case SUBMIT_RETURN_APPROVALS_ACTION_PENDING: {
      return {
        ...localState,
        isPending: true,
      };
    }
    case CLEAR_SUBMIT_RETURN_APPROVALS_ACTION_ERROR: {
      return {
        ...localState,
        errorMessage: null,
      };
    }
    case OPEN_RETURN_APPROVALS_ACTION_MODAL: {
      return {
        ...localState,
        isReturnApprovalActionModalOpen: true,
        errorMessage: null,
      };
    }
    case CLOSE_RETURN_APPROVALS_ACTION_MODAL: {
      return {
        ...localState,
        isReturnApprovalActionModalOpen: false,
      };
    }

    default: {
      return localState;
    }
  }
};
